import utils from '../libs/utils';
import axios from './axios';

const MODULE_NAME = 'v1/erp-report-web';
export default {
  axios,
  invoicingListByDay(params) { // 进销存按天展示列表
    return axios.get(`${MODULE_NAME}/report/psi/list/day?${utils.exchangeParams(params)}`);
  },

  invoicingListByDayExport(params) { // 进销存按天展示导出
    return axios.post(`${MODULE_NAME}/report/psi/export/day`, params);
  },

  invoicingListByDayTotal(params) { // 进销存按天展示合计
    return axios.get(`${MODULE_NAME}/report/psi/total/day?${utils.exchangeParams(params)}`);
  },

  invoicingListByGoods(params) { // 进销存按品
    return axios.get(`${MODULE_NAME}/report/psi/list/goods?${utils.exchangeParams(params)}`);
  },

  invoicingListByGoodsExport(params) { // 进销存按品导出
    return axios.post(`${MODULE_NAME}/report/psi/export/goods`, params);
  },

  invoicingListByGoodsTotal(params) { // 进销存按品合计
    return axios.get(`${MODULE_NAME}/report/psi/total/goods?${utils.exchangeParams(params)}`);
  },

  retailDecisionAnalysisByDay(params) { // 零售决策按天展示列表
    return axios.get(`${MODULE_NAME}/report/sale/list/day?${utils.exchangeParams(params)}`);
  },

  retailDecisionAnalysisByDayExport(params) { // 零售决策按天展示导出
    return axios.post(`${MODULE_NAME}/report/sale/export/day`, params);
  },

  retailDecisionAnalysisByDayTotal(params) { // 零售决策按天展示合计
    return axios.get(`${MODULE_NAME}/report/sale/total/day?${utils.exchangeParams(params)}`);
  },

  retailDecisionAnalysisByStore(params) { // 零售决策按门店展示列表
    return axios.get(`${MODULE_NAME}/report/sale/list/store?${utils.exchangeParams(params)}`);
  },

  retailDecisionAnalysisByStoreTotal(params) { // 零售决策按门店合计
    return axios.get(`${MODULE_NAME}/report/sale/total/store?${utils.exchangeParams(params)}`);
  },

  retailDecisionAnalysisByStoreExport(params) { // 零售决策按门店导出
    return axios.post(`${MODULE_NAME}/report/sale/export/store`, params);
  },

  inboundReturnDecision(params) { // 入库退货决策
    return axios.get(`${MODULE_NAME}/report/inventoryRecord/list?${utils.exchangeParams(params)}`);
  },

  inboundReturnDecisionTotal(params) { // 入库退货决策合计
    return axios.get(`${MODULE_NAME}/report/inventoryRecord/total?${utils.exchangeParams(params)}`);
  },

  inboundReturnDecisionExport(params) { // 入库退货决策导出
    return axios.post(`${MODULE_NAME}/report/inventoryRecord/export`, params);
  },

  inventoryTurnoverAnalysisByStore(params) { // 库存周转分析按门店
    return axios.get(`${MODULE_NAME}/report/inventoryTurnover/list/store?${utils.exchangeParams(params)}`);
  },

  inventoryTurnoverAnalysisByStoreExport(params) { // 库存周转分析按门店导出
    return axios.post(`${MODULE_NAME}/report/inventoryTurnover/export/store`, params);
  },

  inventoryTurnoverAnalysisByStoreTotal(params) { // 库存周转分析按门店合计
    return axios.get(`${MODULE_NAME}/report/inventoryTurnover/total/store?${utils.exchangeParams(params)}`);
  },

  inventoryTurnoverAnalysisByGoods(params) { // 库存周转分析按品
    return axios.get(`${MODULE_NAME}/report/inventoryTurnover/list/goods?${utils.exchangeParams(params)}`);
  },

  inventoryTurnoverAnalysisByGoodsTotal(params) { // 库存周转分析按品合计
    return axios.get(`${MODULE_NAME}/report/inventoryTurnover/total/goods?${utils.exchangeParams(params)}`);
  },

  inventoryTurnoverAnalysisByGoodsExport(params) { // 库存周转分析按品导出
    return axios.post(`${MODULE_NAME}/report/inventoryTurnover/export/goods`, params);
  },

  nonmovingDecisionAnalysis(params) { // 不动销决策分析
    return axios.get(`${MODULE_NAME}/noSales/list?${utils.exchangeParams(params)}`);
  },
  nonmovingDecisionRefresh() {
    return axios.post(`${MODULE_NAME}/noSales/refresh`);
  },
  getNonmovingDecisionRefresh() {
    return axios.get(`${MODULE_NAME}/noSales/time/refresh`);
  },
  saleRefresh() {
    return axios.post(`${MODULE_NAME}/report/sale/refresh`);
  },
  getSaleRefresh() {
    return axios.get(`${MODULE_NAME}/report/sale/time/refresh`);
  },
  inventoryRefresh() {
    return axios.post(`${MODULE_NAME}/report/inventoryRecord/refresh`);
  },
  getInventoryRefresh() {
    return axios.get(`${MODULE_NAME}/report/inventoryRecord/time/refresh`);
  },

  nonmovingDecisionAnalysisExport(params) { // 不动销决策分析导出
    return axios.post(`${MODULE_NAME}/noSales/export`, utils.exchangeParams(params));
  },

  nonmovingDecisionAnalysisTotal(params) { // 不动销决策分析合计
    return axios.get(`${MODULE_NAME}/noSales/total?${utils.exchangeParams(params)}`);
  },
  getReportFile(params) {
    return axios.get(`${MODULE_NAME}/report/file/get?${utils.exchangeParams(params)}`);
  },
  downloadReportFile(params) {
    return axios.get(`${MODULE_NAME}/report/file/download?${utils.exchangeParams(params)}`, {
      responseType: 'blob',
    });
  },
  getPurchaseSaleInventoryList(params) { // 进销存总部列表
    return axios.get(`${MODULE_NAME}/report/finance/biz/list?${utils.exchangeParams(params)}`);
  },
  getPurchaseSaleInventoryTotal(params) { // 进销存总部合计
    return axios.get(`${MODULE_NAME}/report/finance/biz/total?${utils.exchangeParams(params)}`);
  },

  financeBizReportExport(params) { // 进销存总部导出
    return axios.post(`${MODULE_NAME}/report/finance/biz/export`, params);
  },

  getFinanceInReportList(params) { // 财务应付暂估明细列表
    return axios.get(`${MODULE_NAME}/report/finance/in/list?${utils.exchangeParams(params)}`);
  },
  getFinanceInReportTotal(params) { // 财务应付暂估明细合计
    return axios.get(`${MODULE_NAME}/report/finance/in/total?${utils.exchangeParams(params)}`);
  },
  financeInReportExport(params) { // 财务应付暂估明细导出
    return axios.post(`${MODULE_NAME}/report/finance/in/export`, params);
  },
  /* 数据统计接口 */
  // 统计视图[年维度] - 列表
  getStatisticsYearList(params) {
    return axios.get(`${MODULE_NAME}/report/sale/statistics/year/list?${utils.exchangeParams(params)}`);
  },
  // 统计视图[年维度] - 合计
  getStatisticsYearTotal(params) {
    return axios.get(`${MODULE_NAME}/report/sale/statistics/year/total?${utils.exchangeParams(params)}`);
  },
  // 统计视图[年维度] - 导出
  getStatisticsYearExport(params) {
    return axios.post(`${MODULE_NAME}/report/sale/statistics/year/export`, utils.exchangeParams(params));
  },

  // 统计视图[月维度] - 列表
  getStatisticsMonthList(params) {
    return axios.get(`${MODULE_NAME}/report/sale/statistics/month/list?${utils.exchangeParams(params)}`);
  },
  // 统计视图[月维度] - 合计
  getStatisticsMonthTotal(params) {
    return axios.get(`${MODULE_NAME}/report/sale/statistics/month/total?${utils.exchangeParams(params)}`);
  },
  // 统计视图[月维度] - 导出
  getStatisticsMonthExport(params) {
    return axios.post(`${MODULE_NAME}/report/sale/statistics/month/export`, utils.exchangeParams(params));
  },
  getStatisticsViewDetail(params) {
    return axios.get(`${MODULE_NAME}/report/sale/statistics/year/detail?${utils.exchangeParams(params)}`);
  },
  // 统计视图详情 - 导出查询结果
  getStatisticsDetailExport(params) {
    return axios.post(`${MODULE_NAME}/report/sale/statistics/year/detail/export`, utils.exchangeParams(params));
  },
  // 统计视图详情 - 导出全部
  getStatisticsDetailAllExport(params) {
    return axios.post(`${MODULE_NAME}/report/sale/statistics/year/detail/export/all`, utils.exchangeParams(params));
  },
  getReceiveDepositList(params) { // 应收预收报表-列表
    return axios.get(`${MODULE_NAME}/report/finance/receiveDeposit/list?${utils.exchangeParams(params)}`);
  },
  // 应收预收报表-导出
  downloadReceiveDeposit(params) {
    return axios.post(`${MODULE_NAME}/report/finance/receiveDeposit/download`, params);
  },
  unsaleList(params) { // 滞销
    return axios.get(`${MODULE_NAME}/noSales/unsale/list?${utils.exchangeParams(params)}`);
  },
  unsaleListExport(params) { // 导出
    return axios.get(`${MODULE_NAME}/noSales/unsale/export?${utils.exchangeParams(params)}`);
  },
  // top20
  drugRank(params) {
    return axios.get(`${MODULE_NAME}/report/daily/topTwentySales/list?${utils.exchangeParams(params)}`);
  },
  drugRankExport(params) {
    return axios.get(`${MODULE_NAME}/report/daily/topTwentySales/download?${utils.exchangeParams(params)}`);
  },
};
